// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scan_inner[data-v-b5d9e316] {\n  padding: 0 0.9375rem;\n  width: 100%;\n  text-align: center;\n}\n.scan_inner .image-slot[data-v-b5d9e316] {\n  background: #f6f6f6;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  color: #dddee7;\n  font-size: 2.5rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
